import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'limitLoop'})
export class LimitLoop implements PipeTransform {

    public transform(items: [], limit: number) {
        return items.slice(0, limit);
    }
}
